import { Slip } from 'components/Slip/Slip';
import styles from './SportsBettingRightSide.module.css';
import { SlipEntry } from 'types/SlipEntry';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ThemeBanner } from 'components/ThemeBanner/ThemeBanner';
import { readAppliedPlayerTheme, usesLogoTheme } from 'lib/playerTheme';
import { useModernDesktop } from 'components/Layout/ModernDesktopShell';

interface Props {
  slipEntries: SlipEntry[];
  /** The modern desktop shell's own slip (the dock at the bottom). */
  inShell?: boolean;
  /** See Slip's onPayout. */
  onPayout?: (payout: number) => void;
}

export const SportsBettingRightSide = ({
  slipEntries,
  inShell,
  onPayout,
}: Props) => {
  const [scrollerDisabled, setScrollerDisabled] = useState<boolean>(false);
  const navigate = useNavigate();
  const modernDesktop = useModernDesktop();

  const { t } = useTranslation();

  // In the modern desktop layout the shell shows the slip on every page; the
  // pages' own copies stay out.
  if (modernDesktop && !inShell) return null;
  if (inShell) {
    return (
      <div className={styles.shellSlip}>
        {slipEntries && slipEntries.length > 0 ? (
          <Slip entries={slipEntries} docked onPayout={onPayout} />
        ) : (
          <div className={styles.emptySlip}>
            <span aria-hidden>🧾</span>
            <strong>{t('modern_slip_empty_title')}</strong>
            <p>{t('empty_bet_slip_message')}</p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={
        slipEntries && slipEntries.length > 0 && !scrollerDisabled
          ? styles.sticky
          : ''
      }
    >
      <div className={styles.betSlip}>
        {slipEntries && slipEntries.length > 0 ? (
          <Slip entries={slipEntries} />
        ) : (
          <>
            <div className={styles.betSlipTitle}>{t('slip_label')}</div>
            <div className={styles.betSlipMessage}>
              {t('empty_bet_slip_message')}
            </div>
          </>
        )}
      </div>
      <div
        className={styles.scrollerToggler}
        onClick={() => setScrollerDisabled(!scrollerDisabled)}
      >
        {scrollerDisabled
          ? t('enable_scrolling_label')
          : t('disable_scrolling_label')}
      </div>
      <div
        className={styles.resultsWrapper}
        onClick={() => navigate('/results')}
      >
        <div className={styles.betSlipTitle}>{t('results_label')}</div>
        {usesLogoTheme(readAppliedPlayerTheme()) ? (
          <img src="/photos/results-banner.png" alt="Results" />
        ) : (
          <ThemeBanner kind="results" />
        )}
      </div>
    </div>
  );
};
